export default function reduce(initialState, handlers) {
    return (state = initialState, action = {}) => {
        const handler = handlers[action.type];
        return handler ? handler(state, action) : state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reduce.js